import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const NewsletterUnsubscribed = () => {
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status") || "error";
  const ptaName = searchParams.get("pta") || "this PTA";
  const message = searchParams.get("message") || "An unexpected error occurred. Please try again later.";

  const isSuccess = status === "success";

  return (
    <div className="min-h-screen bg-muted flex flex-col items-center justify-center p-6">
      <div className="mb-8 text-center">
        <span className="text-xl font-bold text-primary tracking-tight">PTA Hub</span>
      </div>

      <Card className="max-w-md w-full text-center shadow-lg">
        <CardContent className="pt-10 pb-8 px-8">
          {isSuccess ? (
            <div className="mx-auto mb-6 w-16 h-16 rounded-full bg-green-100 flex items-center justify-center">
              <CheckCircle2 className="w-8 h-8 text-green-600" />
            </div>
          ) : (
            <div className="mx-auto mb-6 w-16 h-16 rounded-full bg-red-100 flex items-center justify-center">
              <XCircle className="w-8 h-8 text-red-600" />
            </div>
          )}

          <h1 className="text-xl font-bold text-foreground mb-3">
            {isSuccess ? "You've been removed from the newsletter" : "Something went wrong"}
          </h1>

          <p className="text-muted-foreground text-sm leading-relaxed mb-7">
            {isSuccess ? (
              <>
                You will no longer receive newsletter emails from{" "}
                <strong className="text-foreground">{ptaName}</strong>. You can
                re-subscribe at any time from your parent profile.
              </>
            ) : (
              message
            )}
          </p>

          <Button asChild>
            <Link to="/">Visit PTA Hub</Link>
          </Button>
        </CardContent>
      </Card>

      <p className="mt-8 text-xs text-muted-foreground">
        &copy; {new Date().getFullYear()} PTA Hub
      </p>
    </div>
  );
};

export default NewsletterUnsubscribed;
